(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer-recommendations')) {
    customElements.define(
      'cart-drawer-recommendations',
      class CartDrawerRecommendations extends HTMLElement {
        connectedCallback() {
          this.onCartUpdate = this.onCartUpdate.bind(this);
          document.addEventListener('cart:update', this.onCartUpdate);

          // On first render, if we're in "related" mode with items in the cart,
          // upgrade the collection fallback to related products.
          if (this.dataset.source === 'related' && this.dataset.isEmpty !== 'true' && this.dataset.latestId) {
            this.loadRelated(this.dataset.latestId);
          }
        }

        disconnectedCallback() {
          document.removeEventListener('cart:update', this.onCartUpdate);
        }

        onCartUpdate() {
          if (this.dataset.source !== 'related') return;

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((cart) => {
              if (!cart.items || cart.items.length === 0) return;
              const latest = cart.items[cart.items.length - 1];
              if (latest && latest.product_id) this.loadRelated(latest.product_id);
            })
            .catch(() => {});
        }

        loadRelated(productId) {
          if (!productId || !this.dataset.endpoint) return;

          const url = `${this.dataset.endpoint}&product_id=${productId}`;
          this.cache = this.cache || {};

          // The drawer re-renders (morphs) on every cart change, which resets us back
          // to the server-rendered collection fallback — so always re-inject, using a
          // cached response when we've already fetched this product's recommendations.
          if (this.cache[url] !== undefined) {
            this.inject(this.cache[url]);
            return;
          }

          fetch(url)
            .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
            .then((html) => {
              this.cache[url] = html;
              this.inject(html);
            })
            .catch(() => {});
        }

        inject(html) {
          const parsed = document.createElement('div');
          parsed.innerHTML = html;
          const slider = parsed.querySelector('cart-product-slider');

          // Only swap in related products if we actually got some; otherwise keep the fallback.
          if (slider && slider.querySelector('.cart-slide-card')) {
            this.replaceChildren(slider);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-product-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-product-slider')) {
    customElements.define(
      'cart-product-slider',
      class CartProductSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[ref="track"]');
          this.prevButton = this.querySelector('[ref="prev"]');
          this.nextButton = this.querySelector('[ref="next"]');

          this.update = this.update.bind(this);

          if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
          if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByCard(1));
          if (this.track) this.track.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update, { passive: true });

          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.update);
        }

        scrollByCard(direction) {
          if (!this.track) return;
          const card = this.track.querySelector('.cart-slide-card');
          const step = card ? card.getBoundingClientRect().width + 12 : this.track.clientWidth * 0.8;
          this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
        }

        update() {
          if (!this.track) return;
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const overflowing = scrollWidth - clientWidth > 2;
          const atStart = scrollLeft <= 1;
          const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

          if (this.prevButton) this.prevButton.toggleAttribute('disabled', !overflowing || atStart);
          if (this.nextButton) this.nextButton.toggleAttribute('disabled', !overflowing || atEnd);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-shipping-bar')) {
    customElements.define(
      'free-shipping-bar',
      class FreeShippingBar extends HTMLElement {
        connectedCallback() {
          this.threshold = parseInt(this.dataset.threshold, 10) || 0;
          this.messageTemplate = this.dataset.message || '';
          this.successMessage = this.dataset.successMessage || '';
          this.moneyFormat = this.dataset.moneyFormat || ('$' + '{' + '{amount}' + '}');
          this.hideWhenEmpty = this.dataset.hideWhenEmpty === 'true';

          this.messageEl = this.querySelector('[ref="message"]');
          this.trackEl = this.querySelector('[ref="track"]');
          this.fillEl = this.querySelector('[ref="fill"]');

          this.onCartUpdate = this.onCartUpdate.bind(this);
          document.addEventListener('cart:update', this.onCartUpdate);
        }

        disconnectedCallback() {
          document.removeEventListener('cart:update', this.onCartUpdate);
        }

        onCartUpdate() {
          fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart.js`, {
            headers: { Accept: 'application/json' },
          })
            .then((response) => response.json())
            .then((cart) => this.render(cart.total_price, cart.item_count))
            .catch(() => {});
        }

        render(totalCents, itemCount) {
          if (this.hideWhenEmpty && itemCount === 0) {
            this.style.display = 'none';
            return;
          }
          this.style.display = '';

          const remaining = Math.max(0, this.threshold - totalCents);
          const percent = this.threshold > 0 ? Math.min(100, (totalCents / this.threshold) * 100) : 0;
          const rounded = Math.round(percent);

          if (this.fillEl) this.fillEl.style.width = `${rounded}%`;
          if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', String(rounded));

          if (this.messageEl) {
            if (remaining <= 0) {
              this.messageEl.innerHTML = this.successMessage;
            } else {
              const amount = `<strong>${this.formatMoney(remaining)}</strong>`;
              this.messageEl.innerHTML = this.messageTemplate.replace('[amount]', amount);
            }
          }
        }

        // Minimal money formatter compatible with Shopify's shop.money_format tokens.
        formatMoney(cents) {
          const format = this.moneyFormat;
          const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
          const token = placeholder ? placeholder[1] : 'amount';

          const formatWithDelimiters = (number, precision, thousands, decimal) => {
            precision = precision == null ? 2 : precision;
            thousands = thousands == null ? ',' : thousands;
            decimal = decimal == null ? '.' : decimal;
            if (isNaN(number)) return '0';
            number = (number / 100).toFixed(precision);
            const parts = number.split('.');
            const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
            const rest = parts[1] ? decimal + parts[1] : '';
            return dollars + rest;
          };

          let formatted;
          switch (token) {
            case 'amount_no_decimals':
              formatted = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              formatted = formatWithDelimiters(cents, 2, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              formatted = formatWithDelimiters(cents, 0, '.', ',');
              break;
            case 'amount_with_space_separator':
              formatted = formatWithDelimiters(cents, 2, ' ', ',');
              break;
            case 'amount_no_decimals_with_space_separator':
              formatted = formatWithDelimiters(cents, 0, ' ', '');
              break;
            default:
              formatted = formatWithDelimiters(cents, 2);
          }

          return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
